import React from 'react'
import { Link } from 'react-router-dom'
import { Menu, Icon, Dropdown } from 'antd'
import memoize from 'memoize-one'
import { inject, observer } from 'mobx-react'
import { getToken } from 'util/utils'
import formatMenuPath from 'util/formatMenuPath'
import getFlatMenuKeys from 'util/getFlatMenuKeys'
import getMenuMatchKeys from 'util/getMenuMatchKeys'
import urlToList from 'util/urlToList'
import { map } from 'lodash'
import Cookie from 'js-cookie'
import Styles from './index.scss'

type menu = {
  name: string
  path: string
  icon?: string
  children?: any[]
}

export interface IProps {
  appBaseUrl: string
  style?: object
  appLogo?: string
  width?: number
  height?: number
  menuData: menu[]
  pathname: string
  userStore?: IUserStore.UserStore
}

@inject('userStore')
@observer
class HeaderMenu extends React.Component<IProps, any> {
  fullPathMenuData: any
  selectedKeys: any

  constructor(props) {
    super(props)

    this.fullPathMenuData = memoize(mData => formatMenuPath(mData))
    this.selectedKeys = memoize((pName, fullPathMenu) =>
      getMenuMatchKeys(getFlatMenuKeys(fullPathMenu), urlToList(pName)),
    )

    const { pathname, menuData } = props

    this.state = {
      selectedKeys: this.selectedKeys(
        pathname,
        this.fullPathMenuData(menuData),
      ),
    }
  }

  renderMenu = data =>
    map(data, item => {
      return (
        <Menu.Item key={item.path}>
          <Link to={item.path} href={item.path}>
            {item.icon && <Icon type={item.icon} />}
            <span>{item.name}</span>
          </Link>
        </Menu.Item>
      )
    })

  renderNavHeader = () => {
    const { appBaseUrl, appLogo } = this.props

    return (
      <Link to={appBaseUrl} href={appBaseUrl}>
        <div className={Styles.header}>
          <img className={Styles.logo} src={appLogo} alt="logo1" />
        </div>
      </Link>
    )
  }

  handleRef = (tid, id) => {
    const token = getToken()
    let domain = 'jingzhuan.cn'
    let path = 'exam.jingzhuan.cn'
    let url = `//${path}/#/home?id=${id}`

    if (process.env.APP_ENV === 'qa') {
      domain = 'atido.com'
      path = 'testexam.atido.com'
      url = `//${path}/?token=${token}&project=soft#/home?id=${id}&tid=${tid}`
    }

    Cookie.set('EXAM_TYPE_ID', tid, { domain })
    window.open(url)
  }

  renderNavBody = () => {
    const { menuData } = this.props
    const { selectedKeys } = this.state

    return (
      <div className={`body`}>
        <Menu mode="horizontal" theme="light" selectedKeys={selectedKeys}>
          {this.renderMenu(this.fullPathMenuData(menuData))}
          <Menu.Item key="hero">
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item>
                    <Link to="/housework">
                      <span>经传家事</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item>
                    <Link to="/team">
                      <span>经传人</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item>
                    <Link to="/honor">
                      <span>经传荣誉</span>
                    </Link>
                  </Menu.Item>
                </Menu>
              }
            >
              <a>经传之家</a>
            </Dropdown>
          </Menu.Item>

          <Menu.Item key="lecturer">
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item>
                    <Link to="/glory">
                      <span>荣耀殿堂</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item>
                    <Link to="/study">
                      <span>专业学习</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item>
                    <a onClick={() => this.handleRef(4, 4)}>从业考证</a>
                  </Menu.Item>
                </Menu>
              }
            >
              <a>讲师进阶</a>
            </Dropdown>
          </Menu.Item>

          {/* <Menu.Item key="course">
            <a onClick={() => this.handleRef(4, 4)}>从业考证</a>
          </Menu.Item> */}

          <Menu.Item key="investor">
            <a href="https://edu.n8n8.cn/" target="_blank">
              股民学校
            </a>
          </Menu.Item>
        </Menu>
      </div>
    )
  }

  render() {
    const { style, width, height } = this.props

    const styles = {
      width,
      height,
      ...style,
    }

    return (
      <div className={Styles.headerMenu} style={styles}>
        {this.renderNavHeader()}
        {this.renderNavBody()}
      </div>
    )
  }
}

export default HeaderMenu
